// HTML slot behavior for grid columns.
//
// Renders server-provided HTML stored in a named slot inside the row
// template. The slot name matches the field name.
//
// Column def:  { field: "purchasedFrom", behavior: "html" }
// Template:    <div data-slot="purchasedFrom"><a href="...">Vendor</a></div>
//
// The grid controller's parseRow extracts the slot into
// `__purchasedFromHtml` which this behavior renders.

export const html = {
  apply() {
    return {
      cellRenderer: (params) => {
        const field = params.colDef.field
        const slotHtml = params.data?.[`__${field}Html`]
        if (!slotHtml || params.node?.rowPinned) return params.value || ""

        const container = document.createElement("span")
        container.innerHTML = slotHtml
        return container
      },
      editable: false
    }
  }
}
